import { LocalDate } from './local-date.model';

export interface Dates {
  plannedDepartureTime: LocalDate;
  plannedArrivalTime: LocalDate;
  estimatedDepartureTime: LocalDate;
  estimatedArrivalTime: LocalDate;
  actualDepartureTime: LocalDate;
  actualArrivalTime: LocalDate;
}
